import React from "react";
import { Routes, Route } from "react-router-dom";
import { registry } from "./registry";

// ── Feature route imports (all at top — import/first) ─────────────────────
// Landing pública en / — propuesta de valor, planes y CTA a registro
import landingRoutes from "../../features/landing/routes";
// TASK-07 — auth: login/registro/activación/reset + dashboards por rol
import authRoutes from "../../features/auth/routes";
// TASK-09 — academy: sedes, paquetes/precios, políticas, tarifas (OWNER)
import academyRoutes from "../../features/academy/routes";
// TASK-12 — teacher: agenda, detalle+continuidad, asistencia, grade card, mis horas
import teacherRoutes from "../../features/teacher/routes";
// TASK-14 — student: diagnóstico, calendario, saldo, pagos, ciclos
import studentRoutes from "../../features/student/routes";
// TASK-16 — billing (owner): honorarios, pagos de estudiante, cartera vencida
import billingRoutes from "../../features/billing/routes";
// TASK-18 — plan (OWNER): plan/facturación/bloques + superadmin (SUPERADMIN/is_staff)
import planRoutes from "../../features/plan/routes";
import superadminRoutes from "../../features/superadmin/routes";
// TASK-19 — privacy (Ley 1581): política pública + "Mis datos personales"
import privacyRoutes from "../privacy/routes";
// Perfil de usuario (info de cuenta + cambio de contraseña) — cualquier rol
import profileRoutes from "../../features/profile/routes";
// Legacy routes migrated from old App.js (R6)
import { legacyRoutes } from "./legacyRoutes";

// ── Register in priority order ─────────────────────────────────────────────
registry.register(landingRoutes);
registry.register(authRoutes);
registry.register(academyRoutes);
registry.register(teacherRoutes);
registry.register(studentRoutes);
registry.register(billingRoutes);
registry.register(planRoutes);
registry.register(superadminRoutes);
registry.register(privacyRoutes);
registry.register(profileRoutes);
registry.register(legacyRoutes);

/**
 * Renders a <Route> for each object in the registry.
 * Supports flat routes and one level of nesting (children).
 */
function renderRoutes(routes) {
  return routes.map((route) => {
    const { path, element, children, index } = route;
    if (children) {
      return (
        <Route key={path} path={path} element={element}>
          {renderRoutes(children)}
        </Route>
      );
    }
    if (index) {
      return <Route key={`${path ?? "index"}-index`} index element={element} />;
    }
    return <Route key={path} path={path} element={element} />;
  });
}

function AppRouter() {
  return <Routes>{renderRoutes(registry.routes)}</Routes>;
}

export { AppRouter };
